__turbopack_export_value__({
  "assessment": "footerInfo-module-scss-module__vqLT3q__assessment",
  "assessment__button": "footerInfo-module-scss-module__vqLT3q__assessment__button",
  "assessment__text": "footerInfo-module-scss-module__vqLT3q__assessment__text",
  "assessment__wrapper": "footerInfo-module-scss-module__vqLT3q__assessment__wrapper",
  "body-logo-18": "footerInfo-module-scss-module__vqLT3q__body-logo-18",
  "body-text-12": "footerInfo-module-scss-module__vqLT3q__body-text-12",
  "body-text-14": "footerInfo-module-scss-module__vqLT3q__body-text-14",
  "body-text-16": "footerInfo-module-scss-module__vqLT3q__body-text-16",
  "body-text-18": "footerInfo-module-scss-module__vqLT3q__body-text-18",
  "body-text-20": "footerInfo-module-scss-module__vqLT3q__body-text-20",
  "body-text-24": "footerInfo-module-scss-module__vqLT3q__body-text-24",
  "body-text-24-2": "footerInfo-module-scss-module__vqLT3q__body-text-24-2",
  "body-text-heading-2": "footerInfo-module-scss-module__vqLT3q__body-text-heading-2",
  "body-text-heading-3": "footerInfo-module-scss-module__vqLT3q__body-text-heading-3",
  "body-text-medium-14": "footerInfo-module-scss-module__vqLT3q__body-text-medium-14",
  "body-text-medium-16": "footerInfo-module-scss-module__vqLT3q__body-text-medium-16",
  "body-text-medium-18": "footerInfo-module-scss-module__vqLT3q__body-text-medium-18",
  "body-text-medium2-18": "footerInfo-module-scss-module__vqLT3q__body-text-medium2-18",
  "body-text2-14": "footerInfo-module-scss-module__vqLT3q__body-text2-14",
  "body-text2-16": "footerInfo-module-scss-module__vqLT3q__body-text2-16",
  "bottom": "footerInfo-module-scss-module__vqLT3q__bottom",
  "button-primary-text": "footerInfo-module-scss-module__vqLT3q__button-primary-text",
  "button-text": "footerInfo-module-scss-module__vqLT3q__button-text",
  "button2-text": "footerInfo-module-scss-module__vqLT3q__button2-text",
  "captions": "footerInfo-module-scss-module__vqLT3q__captions",
  "captions__wrapper": "footerInfo-module-scss-module__vqLT3q__captions__wrapper",
  "card-shadow": "footerInfo-module-scss-module__vqLT3q__card-shadow",
  "companyInfo": "footerInfo-module-scss-module__vqLT3q__companyInfo",
  "companyInfo__inner": "footerInfo-module-scss-module__vqLT3q__companyInfo__inner",
  "copyright": "footerInfo-module-scss-module__vqLT3q__copyright",
  "desktopOnly": "footerInfo-module-scss-module__vqLT3q__desktopOnly",
  "effect-menu": "footerInfo-module-scss-module__vqLT3q__effect-menu",
  "eyeglasses": "footerInfo-module-scss-module__vqLT3q__eyeglasses",
  "header-1": "footerInfo-module-scss-module__vqLT3q__header-1",
  "leftSide": "footerInfo-module-scss-module__vqLT3q__leftSide",
  "location": "footerInfo-module-scss-module__vqLT3q__location",
  "logo": "footerInfo-module-scss-module__vqLT3q__logo",
  "logoBlock": "footerInfo-module-scss-module__vqLT3q__logoBlock",
  "main-container": "footerInfo-module-scss-module__vqLT3q__main-container",
  "main-footer-container": "footerInfo-module-scss-module__vqLT3q__main-footer-container",
  "main-header-container": "footerInfo-module-scss-module__vqLT3q__main-header-container",
  "menuGrid": "footerInfo-module-scss-module__vqLT3q__menuGrid",
  "menuItem": "footerInfo-module-scss-module__vqLT3q__menuItem",
  "nav": "footerInfo-module-scss-module__vqLT3q__nav",
  "navWrapper": "footerInfo-module-scss-module__vqLT3q__navWrapper",
  "socialIcons": "footerInfo-module-scss-module__vqLT3q__socialIcons",
  "socialLinks": "footerInfo-module-scss-module__vqLT3q__socialLinks",
  "textWrapper": "footerInfo-module-scss-module__vqLT3q__textWrapper",
  "top": "footerInfo-module-scss-module__vqLT3q__top",
  "txt-12-bold": "footerInfo-module-scss-module__vqLT3q__txt-12-bold",
  "txt-14-bold": "footerInfo-module-scss-module__vqLT3q__txt-14-bold",
  "txt-14-bold-caps": "footerInfo-module-scss-module__vqLT3q__txt-14-bold-caps",
  "txt-14-med": "footerInfo-module-scss-module__vqLT3q__txt-14-med",
  "txt-16-bold": "footerInfo-module-scss-module__vqLT3q__txt-16-bold",
  "txt-16-med": "footerInfo-module-scss-module__vqLT3q__txt-16-med",
  "txt-18-bold": "footerInfo-module-scss-module__vqLT3q__txt-18-bold",
  "txt-18-medium": "footerInfo-module-scss-module__vqLT3q__txt-18-medium",
  "txt-18-medium-24": "footerInfo-module-scss-module__vqLT3q__txt-18-medium-24",
  "txt-24-semi": "footerInfo-module-scss-module__vqLT3q__txt-24-semi",
});
